import React from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import {
  Container,
  Button,
  Segment,
  Form,
} from "semantic-ui-react";

import { useNavigate } from "react-router-dom";
import { Formik } from "formik";

import dayjs from "dayjs";
import * as Yup from "yup";
import moment from "moment";


// ===============================================
// Guest House Locations
// These IDs come from dbo.GuestHouseLocations
//
// id | locationId | name
// ----------------------
// 1  | 1          | Lagos
// 2  | 2          | Port Harcourt
//
// We send locationId to the backend,
// not the location name.
// ===============================================

const locationOptions = [
  {
    key: "lagos",
    text: "Lagos",
    value: 1,
  },
  {
    key: "port-harcourt",
    text: "Port Harcourt",
    value: 2,
  },
];


const CheckRoom = (props) => {

  const navigate = useNavigate();


  // ===============================================
  // Handle room availability search
  // ===============================================

  const handleSearch = async (values) => {

    try {

      const checkin = moment(values.checkin)
        .format("YYYY-MM-DD");

      const checkout = moment(values.checkout)
        .format("YYYY-MM-DD");


      const locationId = values.locationId;


      // Build URL with search parameters
      const query =
        `?checkin=${checkin}` +
        `&checkout=${checkout}` +
        `&locationId=${locationId}`;


      if (props?.path) {

        navigate(`${props.path}${query}`);

      } else {

        navigate(`available-rooms${query}`);

      }


    } catch (error) {

      console.error(error);

    }

  };



  // ===============================================
  // Form validation
  // ===============================================

  const schema = Yup.object().shape({

    locationId: Yup.number()
      .required("Location is required"),

    checkin: Yup.string()
      .required("Required"),

    checkout: Yup.string()
      .required("Required"),

  });



  return (

    <Container>

      <Segment
        style={{
          backgroundColor: "transparent",
        }}
      >

        <Formik

          enableReinitialize={true}


          initialValues={{

            locationId: "",

            checkin: "",

            checkout: "",

          }}


          validationSchema={schema}


          onSubmit={(values, { resetForm }) => {

            handleSearch(values);

            resetForm();

          }}

        >

          {(props) => {

            const {

              values,

              touched,

              errors,

              handleSubmit,

              setFieldValue,

            } = props;


            return (

              <Form onSubmit={handleSubmit}>


                <Form.Group widths={3}>


                  {/* ===========================
                      Location Dropdown
                     =========================== */}

                  <Form.Select

                    label="Location"

                    placeholder="Select Location"

                    options={locationOptions}

                    value={values.locationId}

                    onChange={(e, { value }) => {

                      setFieldValue(
                        "locationId",
                        value
                      );

                    }}

                    error={
                      touched.locationId &&
                      errors.locationId
                    }

                  />



                  {/* ===========================
                      Check-in Date
                     =========================== */}

                  <Form.Input

                    control={ReactDatePicker}

                    placeholderText="Select a date"

                    minDate={
                      dayjs().toDate()
                    }

                    maxDate={
                      dayjs()
                        .add(3, "month")
                        .toDate()
                    }


                    label="Check-in Date"


                    selected={
                      values.checkin
                        ? dayjs(values.checkin)
                            .toDate()
                        : null
                    }


                    onChange={(value)=>{

                      setFieldValue(
                        "checkin",
                        value
                      );

                    }}


                    error={
                      touched.checkin &&
                      errors.checkin
                    }

                  />




                  {/* ===========================
                      Check-out Date
                     =========================== */}

                  <Form.Input

                    control={ReactDatePicker}

                    disabled={
                      !values.checkin
                    }


                    placeholderText="Select a date"


                    minDate={
                      dayjs(values.checkin)
                        .add(1,"day")
                        .toDate()
                    }


                    maxDate={
                      dayjs()
                        .add(3,"month")
                        .toDate()
                    }
                    label="Check-out Date"
                    selected={
                      values.checkout
                        ? dayjs(values.checkout)
                            .toDate()
                        : null
                    }

                    onChange={(value)=>{
                      setFieldValue(
                        "checkout",
                        value
                      );

                    }}

                    error={
                      touched.checkout &&
                      errors.checkout
                    }

                  />
                </Form.Group>

                <Button
                  type="submit"
                  style={{
                    backgroundColor:"#26f09e",
                    color:"#000000",
                    width:"100%",
                  }}

                  content="Check Available Rooms"

                />


              </Form>

            );

          }}


        </Formik>


      </Segment>


    </Container>

  );

};


export default CheckRoom;